import { Popover, Skeleton } from 'antd';
import AC from '../AccessControl';
import LicenseTooltip from './LicenseTooltip';
import { LockFilled } from '@ant-design/icons';
import PopoverContent from '../contentDisplay/PopoverContent';
import styles from './Thumbnail.module.scss';
const Thumbnail = ({
  data,
  language,
  link
}) => {
  const imageURL = language !== 'es' ? data.imageURL : data.spanishImageURL;
  const title = language !== 'es' ? data.name : data.spanishName;
  const image = <img src={imageURL} alt={title} />;
  return <AC.CheckAccess rule={AC.ruleFromHref(link)} loadType={<Skeleton.Image active={true} style={{
    width: 160,
    height: 100
  }} />} ifCant={<Popover content={<LicenseTooltip title={title} />} style={{
    maxWidth: 330
  }}>
          <div className={styles.libraryThumbnail} key={data.id}>
            <div className={styles.locked}>
              {image}
              <LockFilled className={styles.lock} />
            </div>
          </div>
        </Popover>} children={<Popover mouseEnterDelay={0.7} mouseLeaveDelay={0.3} content={<PopoverContent data={data} />} style={{
    maxWidth: 330
  }} title={title}>
          <div className={styles.libraryThumbnail} key={data.id}>
            <AC.Link href={link} label={image} />
          </div>
        </Popover>} data-sentry-element="unknown" data-sentry-component="Thumbnail" data-sentry-source-file="Thumbnail.jsx" />;
};
export default Thumbnail;